import { TextField } from '@mui/material';
import { useController } from 'react-hook-form';
import NumberFormat from 'react-number-format';

type NumberTextFieldProps = {
    name: string;
    label: string;
    prefix?: string;
    suffix?: string;
    rules?: Object;
    error?: boolean;
    helperText?: string;
};

export default function NumberTextField({
    name,
    label,
    prefix,
    suffix,
    rules,
    error,
    helperText,
}: NumberTextFieldProps) {
    const {
        field: { value, onChange },
    } = useController({
        name,
        rules,
    });
    return (
        <NumberFormat
            prefix={prefix}
            suffix={suffix}
            thousandSeparator={true}
            customInput={TextField}
            onValueChange={v => onChange(v.value)}
            value={value}
            fullWidth
            decimalScale={2}
            label={label}
            error={error}
            helperText={helperText}
        />
    );
}
